// frontend/src/pages/DashboardPage.js
import React, { useState } from 'react';
import { 
  Container, Row, Col, Card, Form, Button, 
  InputGroup, Badge, Alert, Image,
  OverlayTrigger, Tooltip , Spinner,FloatingLabel,Dropdown,
} from 'react-bootstrap';

import toast from 'react-hot-toast';
import { onboardingService, dashboardService } from '../utils/Api';
import Icon from '../components/Icon';
import QrCodeModal from '../components/QrCodeModal';
import { 
  Instagram, Twitter, GitHub, Linkedin, Globe, 
  Youtube, Facebook, Link as LinkIcon, 
  Image as ImageIcon, Save, Eye,
  Trash2, Plus, ChevronUp, ChevronDown,
  Droplet, AlertCircle , Coffee, Twitch, MessageCircle , Headphones, Heart , X , Info, Send, Check,
  Grid
} from 'react-feather';


import { useAuth , updateUser } from '../context/AuthContext';
import { useDashboard } from '../hooks/useDashboard';
import DashboardLayout from '../layouts/DashboardLayaut';
import useUsernameValidation from '../hooks/useUserNameValidation';
import '../assets/css/DashboardPage.css';



const WHATSAPP_URL_PREFIX = 'https://wa.me/';
const WHATSAPP_MIN_DIGITS = 8;

const cleanPhoneDigits = (value) => (value || '').replace(/\D/g, '');
const buildWhatsappUrl = (rawValue) => `${WHATSAPP_URL_PREFIX}${cleanPhoneDigits(rawValue)}`;
const getWhatsappDigits = (url) => cleanPhoneDigits((url || '').replace(WHATSAPP_URL_PREFIX, ''));
const WhatsappIcon = (props) => <Icon name="whatsapp" {...props} />;

const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const IMAGE_UPLOAD_CONFIG = {
  avatar: { maxSizeMB: 2, field: 'icon_url', uploadFn: dashboardService.uploadAvatar, removeFn: dashboardService.removeAvatar },
  banner: { maxSizeMB: 4, field: 'background_image_url', uploadFn: dashboardService.uploadBanner, removeFn: dashboardService.removeBanner }
};

const DashboardPage = () => {

    // const { user, updateUser } = useAuth(); // Asegúrate de tener updateUser en tu contexto
  const [savingUsername, setSavingUsername] = useState(false);
  const { user ,updateUser} = useAuth();

    // Usar el hook para la validación del username
  const {
    username,
    handleUsernameChange,
    updateUsername,
    validationState,
    checking,
    getInputValidationState,
    getValidationIcon,
    inputProps
  } = useUsernameValidation(user?.username || '');




  const {
    links,
    setLinks,
    profile,
    setProfile,
    loading,
    saving,
    error,
    saveChanges
  } = useDashboard();

  const [newLink, setNewLink] = useState({ title: '', url: '', icon: 'link' });
  const [showPreview, setShowPreview] = useState(true);
  const [uploadingImage, setUploadingImage] = useState({ avatar: false, banner: false });
  const [showQrModal, setShowQrModal] = useState(false);

  const handleImageUpload = async (e, type) => {
    const file = e.target.files?.[0];
    e.target.value = ''; // permite volver a elegir el mismo archivo si hace falta reintentar
    if (!file) return;

    const config = IMAGE_UPLOAD_CONFIG[type];

    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.error('Formato no soportado. Usá JPG, PNG o WebP.');
      return;
    }
    if (file.size > config.maxSizeMB * 1024 * 1024) {
      toast.error(`La imagen supera el tamaño máximo permitido (${config.maxSizeMB}MB).`);
      return;
    }

    setUploadingImage((prev) => ({ ...prev, [type]: true }));
    try {
      const response = await config.uploadFn(file);
      setProfile((prev) => ({ ...prev, [config.field]: response.data.data.url }));
      toast.success('Imagen actualizada');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al subir la imagen');
    } finally {
      setUploadingImage((prev) => ({ ...prev, [type]: false }));
    }
  };

  const handleImageRemove = async (type) => {
    const config = IMAGE_UPLOAD_CONFIG[type];
    setUploadingImage((prev) => ({ ...prev, [type]: true }));
    try {
      await config.removeFn();
      setProfile((prev) => ({ ...prev, [config.field]: '' }));
    } catch (err) {
      toast.error('Error al eliminar la imagen');
    } finally {
      setUploadingImage((prev) => ({ ...prev, [type]: false }));
    }
  };

  // Iconos disponibles
  const iconOptions = [
    { value: 'instagram', label: 'Instagram', icon: Instagram },
    { value: 'twitter', label: 'Twitter', icon: Twitter },
    { value: 'github', label: 'GitHub', icon: GitHub },
    { value: 'linkedin', label: 'LinkedIn', icon: Linkedin },
    { value: 'youtube', label: 'YouTube', icon: Youtube },
    { value: 'facebook', label: 'Facebook', icon: Facebook },
    { value: 'x', label: 'X', icon: X },
    { value: 'twitch', label: 'Twitch', icon: Twitch },
    { value: 'spotify', label: 'Spotify', icon: Headphones },
    { value: 'corazon', label: 'Corazon', icon: Heart },
    { value: 'info', label: 'Info', icon: Info },
    { value: 'telegram', label: 'Telegram', icon: Send },
    { value: 'mensaje', label: 'Mensaje', icon: MessageCircle },
    { value: 'whatsapp', label: 'WhatsApp', icon: WhatsappIcon },
    { value: 'cafecito', label: 'Cafecito', icon: Coffee },
    { value: 'link', label: 'Link Genérico', icon: LinkIcon },
  ];

  
 // Función para guardar el username
  const handleSaveUsername = async () => {
    if (username === user?.username) {
      toast('Este es tu username actual');
      return;
    }

    if (!validationState.isValid) {
      toast.error('El username no es válido');
      return;
    }

    // Si ya tenía un username, cambiarlo rompe el enlace público y los QR ya
    // compartidos/descargados (apuntan a la URL vieja) — se confirma antes de aplicar.
    if (user?.username) {
      confirmUsernameChange();
      return;
    }

    await applyUsernameChange();
  };

  const applyUsernameChange = async () => {
    setSavingUsername(true);
    const result = await updateUsername(username);

    if (result.success) {
      // Actualizar el usuario en el contexto/localStorage
      // updateUser({ username });
      const updatedUser = { ...user, username };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      if (updateUser) updateUser(updatedUser);
    }
    setSavingUsername(false);
  };

  const confirmUsernameChange = () => {
    const previousUsername = user?.username;
    toast((t) => (
      <div className="d-flex flex-column gap-2">
        <span><strong>¿Quieres cambiar tu nombre de usuario?</strong></span>
        <span>
          Tu enlace público pasará a ser <code>/{username}</code>.
          El enlace y el QR que ya compartiste o descargaste con <code>/{previousUsername}</code> dejarán de funcionar.
        </span>

        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-danger"
            onClick={() => {
              toast.dismiss(t.id);
              applyUsernameChange();
            }}
          >
            Sí, cambiar
          </button>

          <button
            className="btn btn-sm btn-secondary"
            onClick={() => toast.dismiss(t.id)}
          >
            Cancelar
          </button>
        </div>
      </div>
    ), { duration: 10000 });
  };

    // Helper para mostrar el icono apropiado
  const renderValidationIcon = () => {
    const iconType = getValidationIcon();
    
    if (iconType === 'spinner') {
      return <Spinner animation="border" size="sm" variant="primary" />;
    }
    
    if (iconType === 'check') {
      return <Check size={18} className="text-success" />;
    }
    
    if (iconType === 'x') {
      return <X size={18} className="text-danger" />;
    }
    
    if (iconType === 'alert') {
      return <AlertCircle size={18} className="text-danger" />;
    }
    
    return null;
  };

  // Manejadores
const handleAddLink = () => {
    if (links.length >= profile.plan_info.max_links) {
        toast(`Has alcanzado el límite de ${profile.plan_info.max_links} links en la versión ${profile.plan_info.plan_type}`);
        return;
    }

    if (newLink.icon === 'whatsapp' && getWhatsappDigits(newLink.url).length < WHATSAPP_MIN_DIGITS) {
        toast.error('Ingresá un número de WhatsApp válido, con código de país.');
        return;
    }

    // 1. Crear el objeto del nuevo link
    const newLinkObj = {
        id: null,
        title: newLink.title,
        url: newLink.url,
        icon: newLink.icon,
        click_count: 0
    };

    // 2. Añadir el link a la lista
    setLinks([...links, newLinkObj]);

    // 3. Limpiar el formulario
    setNewLink({ title: '', url: '', icon: 'link' });
};

  const confirmDelete = (index) => {
  toast((t) => (
    <div className="d-flex flex-column gap-2">
      <span>¿Eliminar este link?</span>
      <span>Perderás tus metricas.</span>
      
      <div className="d-flex gap-2">
        <button
          className="btn btn-sm btn-danger"
          onClick={() => {
            handleDeleteLink(index);
            toast.dismiss(t.id);
          }}
        >
          Sí, eliminar
        </button>

        <button
          className="btn btn-sm btn-secondary"
          onClick={() => toast.dismiss(t.id)}
        >
          Cancelar
        </button>
      </div>
    </div>
  ));
};
  

  const handleDeleteLink = (index) => {
    const updatedLinks = links.filter((_, i) => i !== index);
    setLinks(updatedLinks);
  };

  const handleMoveLink = (index, direction) => {
    if (
      (direction === 'up' && index === 0) || 
      (direction === 'down' && index === links.length - 1)
    ) return;

    const newLinks = [...links];
    const swapIndex = direction === 'up' ? index - 1 : index + 1;
    [newLinks[index], newLinks[swapIndex]] = [newLinks[swapIndex], newLinks[index]];
    
    setLinks(newLinks);
  };

  const handleLinkChange = (index, field, value) => {
    const updatedLinks = [...links];
    updatedLinks[index][field] = value;
    setLinks(updatedLinks);
  };

  const handleLinkIconSelect = (index, iconValue) => {
    const updatedLinks = [...links];
    const current = updatedLinks[index];
    if (iconValue === 'whatsapp') {
      updatedLinks[index] = {
        ...current,
        icon: iconValue,
        url: current.url?.startsWith(WHATSAPP_URL_PREFIX) ? current.url : WHATSAPP_URL_PREFIX
      };
    } else {
      updatedLinks[index] = { ...current, icon: iconValue };
    }
    setLinks(updatedLinks);
  };


  

  const handleSave = async () => {

      if (links.length === 0) {
      toast.error('Agrega al menos un link antes de guardar');
      return;
    }

     await toast.promise(
      saveChanges(),
      {
        loading: '💾 Guardando cambios...',
        success: (data) => {
          return data?.message || '✅ Cambios guardados exitosamente';
        },
        error: (err) => {
          return err?.message || '❌ Error al guardar los cambios';
        },
      },
      {
        // Opciones específicas para esta promesa
        loading: {
          duration: 3000,
          icon: '⏳',
        },
        success: {
          duration: 3000,
          icon: '🎉',
        },
        error: {
          duration: 4000,
          icon: '😵',
        },
      }
    );
  };

  // Vista previa
  const PreviewCard = () => (
    <div 
      className="preview-card p-4 rounded"
      style={{
        backgroundColor: profile.background_color || '#ffffff',
        color: '#212529'
      }}
    >
      {profile.background_image_url && (
        <div className="preview-banner mb-4">
          <Image 
            src={profile.background_image_url} 
            fluid 
            rounded
            style={{ maxHeight: '150px', width: '100%', objectFit: 'cover' }}
            onError={(e) => e.target.style.display = 'none'}
          />
        </div>
      )}
      
      <div className="preview-header text-center mb-4">
        <Image 
          src={profile.icon_url || user?.avatar_url } 
          roundedCircle 
          width={80} 
          height={80}
          className="mb-2 border border-3"
          style={{ borderColor: profile.button_color || '#0d6efd' }}
          onError={(e) => e.target.src = ''}
        />
        <h5 className="mt-2" style={{color: profile.title_color}}>{profile.display_name || user?.name || 'Usuario'}</h5>
        {profile.bio && (
          <p className="small" style={{color: profile.title_color}}>{profile.bio}</p>
        )}
      </div>

      <div className="preview-links">
        {links.map((link, idx) => {
          const IconComponent = iconOptions.find(opt => opt.value === link.icon)?.icon || LinkIcon;
          return (
            <a
              key={idx}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="preview-link d-flex align-items-center justify-content-between p-3 mb-2 rounded text-decoration-none text-white"
              style={{ backgroundColor: profile.button_color ||'#0d6efd' }}
            >
              <span className="d-flex align-items-center"
              style={{ color: profile.text_color ||'#ffffff' }}>
                <IconComponent size={18} className="me-2" />
                {link.title}
              </span>
              <small className="opacity-75">{link.click_count || 0} clicks</small>
            </a>
          );
        })}
      </div>
    </div>
  );

  if (loading) {
    return (
      <DashboardLayout>
        <Container className="py-5 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </Container>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Container fluid className="px-4">
        {error && (
          <Alert variant="danger" className="mb-4" dismissible>
            <AlertCircle size={18} className="me-2" />
            {error}
          </Alert>
        )}

        <Row>
          {/* Columna izquierda - Vista previa */}
          <Col lg={5} className="mb-4">
            <Card className="sticky-top" style={{ top: '20px' }}>
              <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                <h6 className="mb-0">
                  <Eye size={18} className="me-2" />
                  Vista previa
                </h6>
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => setShowQrModal(true)}
                  >
                    <Grid size={14} className="me-1" />
                    QR
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => {

                      window.open(`/${user?.username}`, '_blank')}}
                  >
                    Ver público
                  </Button>
                </div>
              </Card.Header>
              <Card.Body className="preview-wrapper">
                <PreviewCard />
              </Card.Body>
            </Card>
          </Col>

          {/* Columna derecha - Configuración */}
          <Col lg={7}>
            {/* Perfil */}
            <Card className="mb-4">
              <Card.Header>
                <h6 className="mb-0">
                  <ImageIcon size={18} className="me-2" />
                  Perfil
                </h6>
              </Card.Header>
              <Card.Body>
                <Row>
                
                    <Row>
                    <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nombre de Usuario</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>@</InputGroup.Text>
                        <Form.Control
                          type="text"
                          {...inputProps}
                          placeholder="ej: juanperez"
                        />
                        <InputGroup.Text>
                          {renderValidationIcon()}
                        </InputGroup.Text>
                      </InputGroup>
                      
                      {/* Mensajes de validación */}
                      {validationState.message && (
                        <Form.Text 
                          className={
                            validationState.type === 'available' ? 'text-success' :
                            validationState.type === 'unavailable' ? 'text-danger' :
                            validationState.type === 'error' ? 'text-danger' :
                            validationState.type === 'checking' ? 'text-primary' :
                            'text-muted'
                          }
                        >
                          {validationState.type === 'checking' && <Spinner size="sm" className="me-1" />}
                          {validationState.message}
                        </Form.Text>
                      )}

                      {/* Botón para guardar (solo si hay cambios y es válido) */}
                      {username !== user?.username && validationState.isValid && (
                        <Button
                          variant="success"
                          size="sm"
                          className="mt-2"
                          onClick={handleSaveUsername}
                          disabled={savingUsername}
                        >
                          {savingUsername ? 'Guardando...' : 'Actualizar username'}
                        </Button>
                      )}
                    </Form.Group>
                  </Col>
                  </Row>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nombre/Titulo</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Tu nombre"
                        value={profile.display_name || ''}
                        onChange={(e) => setProfile({...profile, display_name: e.target.value})}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Imagen de perfil</Form.Label>
                      <div className="d-flex align-items-center gap-2">
                        <Form.Control
                          type="file"
                          accept="image/jpeg,image/png,image/webp"
                          onChange={(e) => handleImageUpload(e, 'avatar')}
                          disabled={uploadingImage.avatar}
                        />
                        {uploadingImage.avatar && <Spinner animation="border" size="sm" />}
                        {profile.icon_url && !uploadingImage.avatar && (
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleImageRemove('avatar')}
                            title="Quitar imagen"
                          >
                            <Trash2 size={14} />
                          </Button>
                        )}
                      </div>
                      <Form.Text className="text-muted">JPG, PNG o WebP. Máximo 2MB.</Form.Text>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Bio</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        placeholder="Cuéntanos sobre ti..."
                        value={profile.bio || ''}
                        onChange={(e) => setProfile({...profile, bio: e.target.value})}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Imagen de fondo (banner)</Form.Label>
                      <div className="d-flex align-items-center gap-2">
                        <Form.Control
                          type="file"
                          accept="image/jpeg,image/png,image/webp"
                          onChange={(e) => handleImageUpload(e, 'banner')}
                          disabled={uploadingImage.banner}
                        />
                        {uploadingImage.banner && <Spinner animation="border" size="sm" />}
                        {profile.background_image_url && !uploadingImage.banner && (
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleImageRemove('banner')}
                            title="Quitar imagen"
                          >
                            <Trash2 size={14} />
                          </Button>
                        )}
                      </div>
                      <Form.Text className="text-muted">JPG, PNG o WebP. Máximo 4MB.</Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Colores */}
            <Card className="mb-4">
              <Card.Header className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h6 className="mb-0">
                  <Droplet size={18} className="me-2" />
                  Colores
                </h6>
                  {/* Presets en el header */}
                <div className="d-flex align-items-center gap-2">
                <Badge bg="primary" text="light" className="border fw-normal">Temas predefinidos</Badge>
                <div className="d-flex gap-1">
                  <Button
                    variant="light"
                    size="sm" 
                    className="p-1"
                    onClick={() => {
                      setProfile({
                        ...profile,
                        background_color: '#f8f9fa',  // Light
                        button_color: '#0d6efd',       // Primary
                        text_color: '#f8f9fa',         // Dark
                        title_color: '#212529'         // Dark
                      });
                    }}
                    title="Light mode"
                  >
                    <Icon name="sun" size={16} color="#ffc107" /> 
                  </Button>
                  
                  <Button 
                    variant="dark" 
                    size="sm" 
                    className="p-1"
                    onClick={() => {
                      setProfile({
                        ...profile,
                        background_color: '#212529',   // Dark
                        button_color: '#0d6efd',       // Primary
                        text_color: '#f8f9fa',         // Light
                        title_color: '#f8f9fa'         // Light
                      });
                    }}
                    title="Dark mode"
                  >
                    <Icon name="moon" size={16} color="#c6c7c7" /> 
                  </Button>
                  
                  <Button 
                    variant="outline-danger" 
                    size="sm" 
                    className="p-1"
                    onClick={() => {
                      setProfile({
                        ...profile,
                        background_color: '#ffa3c4',   // Red
                        button_color: '#712948',       // Dark
                        text_color: '#f8f9fa',         // Light
                        title_color: '#f8f9fa'         // Light
                      });
                    }}
                    title="Red theme"
                  >
                    <Icon name="fire" size={16} color="#ffa3c4" />
                  </Button>
                  
                  <Button 
                    variant="outline-success" 
                    size="sm" 
                    className="p-1"
                    onClick={() => {
                      setProfile({
                        ...profile,
                        background_color: '#d1f5e4',   // Green
                        button_color: '#198754',       // Light
                        text_color: '#f8f9fa',         // Light
                        title_color: '#212529'         // Light
                      });
                    }}
                    title="Green theme"
                  >
                    <Icon name="leaf" size={16} color="#198754" />
                  </Button>

                  <Button
                    variant="outline-info"
                    size="sm"
                    className="p-1"
                    onClick={() => {
                      setProfile({
                        ...profile,
                        background_color: '#eef7f8',   // Clínico claro
                        button_color: '#0e7490',       // Teal médico
                        text_color: '#f8f9fa',         // Light
                        title_color: '#212529'         // Dark
                      });
                    }}
                    title="Medicina"
                  >
                    <Icon name="medicine" size={16} color="#0e7490" />
                  </Button>
                </div>
                </div>

              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Fondo</Form.Label>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="color"
                          value={profile.background_color || '#ffffff'}
                          onChange={(e) => setProfile({...profile, background_color: e.target.value})}
                          className="me-2"
                          style={{ width: '60px', height: '38px' }}
                        />
                        <Form.Control
                          type="text"
                          value={profile.background_color || '#ffffff'}
                          onChange={(e) => setProfile({...profile, background_color: e.target.value})}
                          size="sm"
                        />
                      </div>
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Botones Links</Form.Label>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="color"
                          value={profile.button_color || '#0d6efd'}
                          onChange={(e) => setProfile({...profile, button_color: e.target.value})}
                          className="me-2"
                          style={{ width: '60px', height: '38px' }}
                        />
                        <Form.Control
                          type="text"
                          value={profile.button_color || '#0d6efd'}
                          onChange={(e) => setProfile({...profile, button_color: e.target.value})}
                          size="sm"
                        />
                      </div>
                    </Form.Group>

                     <Form.Group>
                      <Form.Label>Texto Links</Form.Label>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="color"
                          value={profile.text_color || '#ffffff'}
                          onChange={(e) => setProfile({...profile, text_color: e.target.value})}
                          className="me-2"
                          style={{ width: '60px', height: '38px' }}
                        />
                        <Form.Control
                          type="text"
                          value={profile.text_color || '#ffffff'}
                          onChange={(e) => setProfile({...profile, text_color: e.target.value})}
                          size="sm"
                        />
                      </div>
                    </Form.Group>



                      <Form.Group>
                      <Form.Label>Titulo y BIO</Form.Label>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="color"
                          value={profile.title_color|| '#ffffff'}
                          onChange={(e) => setProfile({...profile, title_color: e.target.value})}
                          className="me-2"
                          style={{ width: '60px', height: '38px' }}
                        />
                        <Form.Control
                          type="text"
                          value={profile.title_color || '#ffffff'}
                          onChange={(e) => setProfile({...profile, title_color: e.target.value})}
                          size="sm"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Links */}
            <Card className="mb-4">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0">
                  <LinkIcon size={18} className="me-2" />
                  Tus enlaces ({links.length}/{profile.plan_info.max_links})
                </h6>
                <Badge bg={links.length === profile.plan_info.max_links ? 'warning' : 'success'}>
                  {links.length === profile.plan_info.max_links ? 'Límite alcanzado' : `${profile.plan_info.max_links - links.length} disponibles`}
                </Badge>
              </Card.Header>
              <Card.Body>
                {/* Lista de links */}
                {links.map((link, index) => {
                  const IconComponent = iconOptions.find(opt => opt.value === link.icon)?.icon || LinkIcon;
                  return (
                    <div key={index} className="link-item mb-3 p-3 border rounded">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex flex-md-row align-items-center">
                          {/* <IconComponent size={20} 
                           className="me-2 text-primary flex-shrink-0" 
                          style={{ 
                            width: 'clamp(20px, 3vw, 24px)',  // Mínimo 20px, máximo 24px, 3% del viewport
                            height: 'auto' 
                          }}  /> */}
                          <Row className=''>
                           <FloatingLabel className='ps-2' label="Título"> 
                          <Form.Control
                            type="text"
                            placeholder="Título"
                            value={link.title}
                            onChange={(e) => handleLinkChange(index, 'title', e.target.value)}
                            className="w-100 mb-1 col-12 "
                            size="sm"
                            style={{ width: '100%' }}
                          />
                           </FloatingLabel>
                          
                           <FloatingLabel className='ps-2' label={link.icon === 'whatsapp' ? 'Número de WhatsApp' : 'URL'}>
                          <Form.Control
                            type={link.icon === 'whatsapp' ? 'tel' : 'text'}
                            placeholder={link.icon === 'whatsapp' ? 'Cód. país + número' : 'URL'}
                            value={link.icon === 'whatsapp' ? getWhatsappDigits(link.url) : link.url}
                            onChange={(e) => handleLinkChange(
                              index,
                              'url',
                              link.icon === 'whatsapp' ? buildWhatsappUrl(e.target.value) : e.target.value
                            )}
                            className=" w-100 mb-1 col-12"
                            size="sm"
                            style={{ width: '100%' }}
                          />
                           </FloatingLabel>
                          
                           {/* <FloatingLabel label="Icono">
                          <Form.Select
                            value={link.icon}
                            onChange={(e) => handleLinkChange(index, 'icon', e.target.value)}
                            size="sm"
                            style={{ width: '100%' }}
                          >
                            
                            {iconOptions.map(opt => (
                              <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                          </Form.Select>
                          </FloatingLabel> */}

                          
                        <Dropdown className='w-100' >
                          <Dropdown.Toggle size="sm" variant="secondary"  className="w-100 d-flex justify-content-between align-items-center  ">
                            {(() => {
                              const selected = iconOptions.find(opt => opt.value === link.icon);
                              if (!selected) return 'Seleccionar icono';

                              const Icon = selected.icon;
                              return (
                                <div className="w-100 d-flex align-items-center justify-content-center gap-2 ">
                                  <Icon size={20} />
                                  {selected.label}
                                </div>
                              );
                            })()}
                          </Dropdown.Toggle>

                          <Dropdown.Menu className='w-100'>
                            {iconOptions.map(opt => {
                              const Icon = opt.icon;
                              return (
                                <Dropdown.Item
                                  key={opt.value}
                                  onClick={() => handleLinkIconSelect(index, opt.value)}
                                  className="w-100 d-flex align-items-center gap-2 "
                                >
                                  <Icon size={16} />
                                  {opt.label}
                                </Dropdown.Item>
                              );
                            })}
                          </Dropdown.Menu>
                        </Dropdown>
                        </Row>
                          
                        </div>
                        <div className='col ms-3 h-100'>
                          <OverlayTrigger overlay={<Tooltip>Subir</Tooltip>}>
                            <Button 
                              variant="light" 
                              size="md" 
                              className="mt-3"
                              onClick={() => handleMoveLink(index, 'up')}
                              disabled={index === 0}
                            >
                              <ChevronUp size={14} />
                            </Button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={<Tooltip>Bajar</Tooltip>}>
                            <Button 
                              variant="light" 
                              size="md" 
                              className="mb-2"
                              onClick={() => handleMoveLink(index, 'down')}
                              disabled={index === links.length - 1}
                            >
                              <ChevronDown size={14} />
                            </Button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={<Tooltip>Eliminar</Tooltip>}>
                            <Button 
                              variant="light" 
                              size="md" 
                              className="text-danger"
                              // onClick={() => handleDeleteLink(index)}
                              onClick={(e) => {
                                  e.preventDefault();
                                  confirmDelete(index);
                                }}
                            >
                              <Trash2 size={14} />
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </div>
                      {link.id && (
                        <span className="badge badge-primary text-white bg-primary">
                          Clicks: {link.click_count || 0}
                        </span>
                      )}
                    </div>
                  );
                })}

                {/* Nuevo link */}
                {links.length < profile.plan_info.max_links && (
                  <div className="new-link-form mt-4 p-3 bg-light rounded">
                    <h6 className="mb-3">Agregar nuevo enlace</h6>
                    <Row>
                      <Col md={5}>
                     
                        <Form.Control
                          type="text"
                          placeholder="Título"
                          value={newLink.title}
                          onChange={(e) => setNewLink({...newLink, title: e.target.value})}
                          size="sm"
                        />
                      </Col>
                      <Col md={4}>
                        {newLink.icon === 'whatsapp' ? (
                          <>
                            <Form.Control
                              type="tel"
                              placeholder="Cód. país + número, ej: 5491122334455"
                              value={getWhatsappDigits(newLink.url)}
                              onChange={(e) => setNewLink({ ...newLink, url: buildWhatsappUrl(e.target.value) })}
                              size="sm"
                            />
                            <Form.Text className="text-muted">Sin espacios ni "+", con código de país.</Form.Text>
                          </>
                        ) : (
                          <Form.Control
                            type="text"
                            placeholder="https://ejemplo.com"
                            value={newLink.url}
                            onChange={(e) => setNewLink({...newLink, url: e.target.value})}
                            size="sm"
                          />
                        )}
                      </Col>
                      <Col md={3}>
                      {/* <Form.Label className='text-muted fs-6 text'> Icono</Form.Label>
                        <Form.Select
                          value={newLink.icon}
                          onChange={(e) => setNewLink({...newLink, icon: e.target.value})}
                          size="sm"
                        >
                          {iconOptions.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </Form.Select> */}

                        <Dropdown >
                          <Dropdown.Toggle size="sm" variant="secondary"  className="w-100 d-flex justify-content-between align-items-center ">
                            {(() => {
                              const selected = iconOptions.find(i => i.value === newLink.icon);
                              if (!selected) return 'Seleccionar icono';

                              const Icon = selected.icon;
                              return (
                                <div className="w-100 d-flex align-items-center justify-content-center gap-2 ">
                                  <Icon size={20} />
                                  {selected.label}
                                </div>
                              );
                            })()}
                          </Dropdown.Toggle>

                          <Dropdown.Menu className='w-100'>
                            {iconOptions.map(opt => {
                              const Icon = opt.icon;
                              return (
                                <Dropdown.Item
                                  key={opt.value}
                                  onClick={() => {
                                    if (opt.value === 'whatsapp') {
                                      setNewLink({
                                        ...newLink,
                                        icon: opt.value,
                                        title: newLink.title || 'WhatsApp',
                                        url: newLink.url.startsWith(WHATSAPP_URL_PREFIX) ? newLink.url : WHATSAPP_URL_PREFIX
                                      });
                                    } else {
                                      setNewLink({ ...newLink, icon: opt.value });
                                    }
                                  }}
                                  className="w-100 d-flex align-items-center gap-2 "
                                >
                                  <Icon size={16} />
                                  {opt.label}
                                </Dropdown.Item>
                              );
                            })}
                          </Dropdown.Menu>
                        </Dropdown>
                      </Col>
                    </Row>
                    <Button 
                      variant="primary" 
                      size="sm"
                      onClick={handleAddLink}
                      disabled={!newLink.title || !newLink.url}
                      className="mt-2 w-100"
                    >
                      <Plus size={16} className="me-1" />
                      Agregar
                    </Button>
                  </div>
                )}
              </Card.Body>
            </Card>

            {/* Botón guardar */}
            <div className="text-center  mb-4 col-12">
              <Button 
                className='col-12 p-2 '
                variant="success" 
                size="lg"
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Guardando...
                  </>
                ) : (
                  <>
                    <Save size={18} className="me-2" />
                    Guardar cambios
                  </>
                )}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <QrCodeModal
        show={showQrModal}
        onHide={() => setShowQrModal(false)}
        url={`${window.location.origin}/${user?.username}`}
        filename={user?.username}
      />
    </DashboardLayout>
  );
};

export default DashboardPage;